<template>
  <header class="site-header">
    <div class="nav-shell">
      <a class="brand" href="/" aria-label="GBApp home">
        <img src="@/assets/gb-logo.webp" alt="GBApp logo">
        <span>GBApp</span>
      </a>

      <button class="menu-toggle" type="button" aria-label="Toggle menu" @click="isOpen = !isOpen">
        <img v-if="!isOpen" src="@/assets/menu.svg" alt="">
        <img v-else src="@/assets/xmark-black.svg" alt="">
      </button>

      <nav class="nav-links" :class="{ 'is-open': isOpen }" aria-label="Primary navigation">
        <a href="/">Home</a>
        <a href="/download/">Download</a>
        <div class="nav-dropdown">
          <a href="/tutorials/" class="dropdown-trigger">Tutorials</a>
          <div class="dropdown-menu">
            <a v-for="item in tutorialNavLinks" :key="item.href" :href="item.href">{{ item.text }}</a>
          </div>
        </div>
        <div class="nav-dropdown">
          <a href="/features/" class="dropdown-trigger">Features</a>
          <div class="dropdown-menu">
            <a v-for="item in featureNavLinks" :key="item.href" :href="item.href">{{ item.text }}</a>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { tutorialNavLinks, featureNavLinks } from '@/data/sitePages';

export default {
  name: 'HeadNav',
  props: {
    selectedLanguage: { type: String, default: 'en' },
    page: { type: String, default: 'home' },
  },
  data() {
    return {
      isOpen: false,
      tutorialNavLinks,
      featureNavLinks,
    };
  },
};
</script>

<style lang="scss" scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(250, 255, 252, 0.94);
  border-bottom: 1px solid rgba(16, 125, 92, 0.12);
  backdrop-filter: blur(18px);
}

.nav-shell {
  max-width: 1180px;
  margin: 0 auto;
  min-height: 72px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #073f32;
  text-decoration: none;
  font-weight: 800;
  font-size: 22px;
  white-space: nowrap;

  img {
    width: 42px;
    height: 42px;
    object-fit: contain;
    border-radius: 12px;
  }
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 6px;

  a,
  button {
    color: #164c40;
    padding: 11px 13px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    text-decoration: none;
    font-size: 14px;
    font-weight: 700;
    font-family: inherit;
    cursor: pointer;
  }

  a:hover,
  button:hover {
    background: #e8f8f2;
  }
}

.nav-dropdown {
  position: relative;
  /* 向下延伸悬停区域，避免鼠标经过间隙时菜单闪退 */
  padding-bottom: 10px;
  margin-bottom: -10px;
}

.dropdown-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &::after {
    content: '';
    flex-shrink: 0;
    width: 6px;
    height: 6px;
    margin-top: -2px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: rotate(45deg);
    transition: transform 0.2s ease;
  }
}

.nav-dropdown:hover .dropdown-trigger::after,
.nav-dropdown:focus-within .dropdown-trigger::after {
  transform: rotate(-135deg);
  margin-top: 2px;
}

.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  width: max-content;
  min-width: 168px;
  max-width: min(220px, calc(100vw - 32px));
  padding: 8px;
  border: 1px solid rgba(16, 125, 92, 0.14);
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 42px rgba(15, 78, 59, 0.16);
  z-index: 20;

  a {
    display: block;
    white-space: nowrap;
  }
}

.nav-dropdown--end .dropdown-menu {
  right: 0;
  left: auto;
}

.nav-dropdown:hover,
.nav-dropdown:focus-within {
  z-index: 30;
}

.nav-dropdown:hover .dropdown-menu,
.nav-dropdown:focus-within .dropdown-menu {
  display: block;
}

.menu-toggle {
  display: none;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(16, 125, 92, 0.16);
  border-radius: 8px;
  background: #ffffff;

  img {
    width: 22px;
    height: 22px;
  }
}

@media (max-width: 820px) {
  .menu-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .nav-shell {
    min-height: 64px;
  }

  .nav-links {
    display: none;
    position: absolute;
    left: 16px;
    right: 16px;
    top: 70px;
    padding: 10px;
    border: 1px solid rgba(16, 125, 92, 0.14);
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 18px 42px rgba(15, 78, 59, 0.16);
    flex-direction: column;
    align-items: stretch;
  }

  .nav-dropdown {
    width: 100%;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .dropdown-trigger {
    width: 100%;
    justify-content: space-between;
    text-align: left;
  }

  .dropdown-menu {
    position: static;
    display: none;
    min-width: 0;
    margin-top: 4px;
    box-shadow: none;
  }

  .nav-links.is-open {
    display: flex;
  }

  .nav-links.is-open .nav-dropdown .dropdown-menu {
    display: grid;
  }
}
</style>
